import { Component, EventEmitter, Input, Output } from '@angular/core';

interface IListButtons {
  title: string;
  description?: string;
  index?: string;
}

@Component({
  selector: 'app-ion-list-buttons',
  templateUrl: './list-buttons.component.html',
  styleUrls: ['./list-buttons.component.scss'],
})
export class ListButtonsComponent {

  @Input()
  id = 'list-button-';

  @Input()
  data: IListButtons[];

  @Output()
  emitClick = new EventEmitter<IListButtons>();


  sendItem(item: IListButtons, index: string) {
    this.emitClick.emit({
      ...item,
      index: `${this.id}${index}`
    });
  }

}
